import { createAction } from 'redux-act';

import TimestampPayload from '../TimestampPayload';

export interface ReservationsUpdated extends TimestampPayload {
  placeUuid: string;
}
export const reservationsUpdated = createAction<ReservationsUpdated>('RESERVATIONS_UPDATED');
